import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function FooterComponent() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <footer className="bg-white py-10 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center md:flex-row md:justify-center md:items-center mb-8">
          <h2 className="sr-only">Download Our App</h2>
          <div className="flex flex-col justify-between w-full sm:flex-row sm:space-x-4">
            <div>
              <a href="#" className="inline-block mb-4 sm:mb-0">
                <img
                  src="https://factsheets.digitallandscape.co.za/site/images/PrimeMarkets-premium-trading.png"
                  alt="Download on the App Store"
                  className="h-12 object-contain"
                />
              </a>
            </div>
            <div>
              <a href="#" className="inline-block mr-2">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="h-12 object-contain"
                />
              </a>
              <a href="#" className="inline-block">
                <img
                  src="https://www.sharenet.co.za/v3/images/appBtn2.png"
                  alt="Get it on Google Play"
                  className="h-12 object-contain"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              Trade
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/forex" className="hover:text-purple-600">Forex</Link></li>
              <li><Link to="/stocks" className="hover:text-purple-600">Stocks</Link></li>
              <li><Link to="/commodities" className="hover:text-purple-600">Commodities</Link></li>
              <li><Link to="/crypto" className="hover:text-purple-600">Cryptocurrencies</Link></li>
              <li><Link to="/indices" className="hover:text-purple-600">Indices</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              Accounts
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/accounts" className="hover:text-purple-600">Account Types Overview</Link></li>
              {/* <li><Link to="/accounts/#individual" className="hover:text-purple-600">Individual Account</Link></li> */}
              {/* <li><Link to="/accounts/#joint" className="hover:text-purple-600">Joint Account</Link></li> */}
              <li><Link to="/accounts" className="hover:text-purple-600">Demo Account</Link></li>
              {/* <li><Link to="/accounts/#corporate" className="hover:text-purple-600">Corporate Account</Link></li> */}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              About Prime Markets
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/about-prime-markets" className="hover:text-purple-600">About Prime Markets</Link></li>
              {/* <li><Link to="/reviews" className="hover:text-purple-600">Reviews</Link></li> */}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              Tools
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/news" className="hover:text-purple-600">News</Link></li>
              <li><Link to="/funding-and-withdrawals" className="hover:text-purple-600">Funding & Withdrawals</Link></li>
              <li><Link to="/faqs" className="hover:text-purple-600">FAQs</Link></li>
              <li><Link to="/economic-calendar" className="hover:text-purple-600">Economic Calendar</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              Legal
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/terms-and-conditions" className="hover:text-purple-600">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-purple-600">Privacy Policy</Link></li>
              <li><Link to="/risk-disclosure" className="hover:text-purple-600">Risk Disclosure</Link></li>
              <li><Link to="/pima-manual" className="hover:text-purple-600">PIMA Manual</Link></li>
              <li><Link to="/complaints-policy" className="hover:text-purple-600">Complaints Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="text-black p-3 text-center text-xs">
        <div className="max-w-7xl mx-auto text-left text-gray-700">
          <h5 className="font-bold ">PrimeMarkets Role</h5>
          <p>
            It's essential for our clients to know that all trades on PrimeMarkets are
            executed through third-party liquidity providers, with whom the responsibility
            for the execution of client orders lies. As an STP broker, PrimeMarkets does
            not have control over the swaps and fees determined by market conditions and
            liquidity providers. Importantly, as a licensed intermediary, PrimeMarkets
            facilitates trades between clients and third-party liquidity providers.
            Consequently, PrimeMarkets operates only as a trading platform and does not
            make a market, issue or sell financial instruments nor is it a money manager or fund manager.
          </p>

          <h5 className="font-bold  mt-2">Regulatory Compliance</h5>
          <p>
            PrimeMarkets PTY Ltd, a corporation duly registered under the laws of South Africa
            (Registration Number: 2023/845826/07; License Number: 54322), with its registered
            office at Club Place, Anton Lambede Street, Durban, 4001, South Africa, is
            authorised and regulated, adhering to the highest standards of compliance and
            transparency. PrimeMarkets does not offer products or services to residents of
            certain jurisdictions including, but not limited to, the USA and Canada.
          </p>

          <h5 className="font-bold  mt-2">Trademark and Legal Notices</h5>
          <p>
            The PrimeMarkets name, logo, and related trademarks are properties of PrimeMarkets,
            protected under trademark law. Unauthorised use is prohibited.
          </p>

          <h5>Risk Warning</h5>
          <p>
            Trading online carries a high level of risk and may not be suitable for all
            investors. Before deciding to trade, consider your investment objectives,
            experience level, and risk appetite. Note that you could incur a loss of some or
            all of your initial investment.
          </p>

          <h5 className="font-bold  mt-2">Privacy and Data Protection</h5>
          <p>
            For privacy concerns, contact{' '}
            <a href="mailto:support@primemarkets.co.za" className="underline">
              support@primemarkets.co.za
            </a>. Read our Privacy Policy for details on data handling. PrimeMarkets is
            compliant with the Protection of Personal Information Act and registered with
            the South African Information Regulator.
          </p>

          <h5 className="font-bold mt-2">Leveraged Trading Note</h5>
          <p>
            Leveraged trading is complex and comes with a high risk of losing money rapidly
            due to leverage. Most retail investor accounts lose money when trading. Understand
            the risks involved and consider seeking independent advice. The investment amount
            refers to the net amount of funds (excluding withdrawals) deposited by the client
            for trading CFDs and making independent investment decisions. For more detailed
            information, please review our Risk Disclosure Statement and Terms and Conditions.
          </p>
        </div>
      </div>
    </footer>
  );
}